import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
// import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { HttpClientModule } from "@angular/common/http";
// import { MatTableModule } from '@angular/material/table';
// angular material imports (move to another file later?)

import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import {ScrollingModule} from '@angular/cdk/scrolling';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatRippleModule } from "@angular/material/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatRadioModule } from "@angular/material/radio";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTableModule } from "@angular/material/table";
//import {MatRaisedButtonModule} from '@angular/material/button';
import { FilterPipe } from "./utils/filterpipe";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";

import { TripStatusDialogComponent, TripRescheduleDialogComponent, ScheduleComponent, ThermalDialogComponent } from "./schedule/schedule/schedule.component";
import { TimeCardDialogComponent, EditTimeModalComponent, StartDayWarningDialogComponent, TimecardNoteDialogComponent, ScheduledJobsWarningDialogComponent } from "./schedule/schedule/timecard-dialog.component";
import { LoginComponent } from "./login/login.component";
import { EditJobComponent } from "./jobs/edit-job/edit-job.component";
import {
  ContactsComponent,
  EditContactDialogComponent,
} from "./contacts/contacts/contacts.component";
import { ContactsService } from "./contacts/contacts.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { TableModule } from "ngx-easy-table";
import {EditLocationDialogComponent, EditJobDialogComponent,ViewFailNotesComponent,LocationComponent, ReportErrorComponent,FlagsDialogComponent, SelectBuilderComponent, SelectHvacContractorComponent, QaReviewResultDialogComponent} from "./location/location.component";
import { LocationService } from "./location/location.service";
import { PlanService } from "./plans/plan.service";
import { CustomerService } from "./customers/customers.service";
import { LoggingService } from "./utils/logging.service";
import { FileUploaderService } from "./utils/photo-upload.service";
import { HomeService } from "./home/home.service";
import { HeatMapService } from "./heatmap/heatmap.service";
import { BCService } from "./builder/builderchecklists.service";
import { GlobalEmailService } from "./utils/globalemail.service";
import {
  PlansComponent,
  EditPlanDialogComponent,
} from "./plans/plans/plans.component";
import { HvacHomeComponent } from "./home1/home.component";
import {
  CustomersComponent,
  EditCustomerDialogComponent,
} from "./customers/customers/customers.component";
import {
  JobtypesComponent,
  EditJobtypeDialogComponent,
} from "./jobs/jobtypes/jobtypes.component";
import {
  EmployeesComponent,
  EditEmployeeDialogComponent,
  WrongSupervisorDialogComponent,
} from "./employee/employee/employees.component";
import {
  EmployeeTreeComponent,
  EmployeeTreeEditDialogComponent,
} from "./employee/employee-tree/employee-tree.component";
import {
  CitiesComponent,
  EditCityDialogComponent,
} from "./cities/cities/cities.component";
import {
  SubdivisionsComponent,
  EditSubdivisionDialogComponent,
  NewScopeDialogComponent,
  NewSubDialogComponent,
} from "./subdivisions/subdivisions/subdivisions.component";
import { AdminscheduleComponent } from "./adminschedule/adminschedule/adminschedule.component";
import { BuilderjobsComponent } from "./builder/builderjobs/builderjobs.component";
import {
  CustomerJobsComponent,
  EditCustomerJobDialogComponent,
} from "./customers/customer-jobs/customer-jobs.component";
import { GridDeleteComponent } from "./utils/grid-delete-component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { EmployeeService } from "./employee/employee.service";
import { SubdivisionService } from "./subdivisions/subdivision.service";
import { MfContactsDialogComponent } from "./subdivisions/subdivisions/mf-contacts-dialog.component";
import { CSVreportsService } from "./csvreports/csvreports.service";
import { JobTypeService } from "src/app/jobs/jobtypes.service";
import { CityService } from "./cities/cities.service";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MessagerComponent } from "./messager/messager/messager.component";
import { ScheduleService } from "./schedule/schedule.service";
import { BigModalDialogComponent, RatingPhotosDialogComponent } from "./schedule/rating-photos/ratingphotos.component";
import { SelfiePromptComponent } from './schedule/selfie-prompt/selfie-prompt.component';
import { VisualmapComponent } from "./visualmap/visualmap.component";
import {
  RaterformComponent,
  RFWarningDialogComponent,
  RaterformSelectorComponent,
  ESPercentDialogComponent,
  AtticTentWarningComponent,
  RFWarningLeakageDialogComponent,
  ESLeakageDialogComponent,
  HvacGradingWarningComponent,
  DuctLeakageWarningComponent,
  BedroomDefinitionDialogComponent,
} from "./raterform/raterform/raterform.component";
import { RaterFormService } from "./raterform/raterform.service";
import { PhotoViewerDialogComponent } from "./raterform/photo-viewer-dialog.component";
import { BillingComponent } from "./billing/billing/billing.component";
import { PlanModalComponent } from "./billing/billing/billing.component";
import { BillingService } from "./billing/billing.service";
import { JobSelectorComponent } from "./jobs/job-selector/job-selector.component";
import { EditableTextareaComponent } from "./editable-textarea/editable-textarea.component";
import { AutofocusDirective } from "./utils/autofocus.directive";
import { AutoOpenSelectDirective } from "./utils/autoopen-select.directive";
import { environment } from "../environments/environment";
import { HeatmapComponent } from "./heatmap/heatmap/heatmap.component";
import { BuilderchecklistsComponent } from "./builder/builderchecklists/builderchecklists.component";
import { BuilderMustCorrectComponent } from "./builder/builderchecklists/builderchecklists.component";
import { VersionComponent } from "./version/version.component";
import { ViewJobLocationsComponent } from "./location//location.component";
import { ExtraNotesRedirectComponent } from "./location/extra-notes-redirect.component";
import { EquipmentComponent } from "src/app/equipment/equipment/equipment.component";
import { ConfirmWarningDialogComponent, HvacLocationComponent, ResetDialogComponent } from "src/app/hvacLocation/locations/location/location.component";
import { LocationFormComponent } from "src/app/hvacLocation/locations/location-form/location-form.component";
import { ViewLocationComponent } from "src/app/hvacLocation/locations/view-location/view-location.component";
import { DesignComponent } from "./design/design/design.component";
import { MatIconModule } from "@angular/material/icon";
import { DesignFormComponent } from "./design/design-form/design-form.component";
import { RemoveDialogComponent, SystemDesignComponent } from "src/app/design/system-design/system-design.component";
import { DesignOverviewComponent } from "./design/design-overview/design-overview.component";
import { HomesComponent } from "./homes/homes.component";
import { EquipmentService } from "src/app/equipment/equipment.service";
import { ViewEquipmentComponent } from "src/app/equipment/view-equipment/view-equipment.component";
import { EquipmentFormComponent } from "src/app/equipment/equipment-form/equipment-form.component";
import { SystemComponent } from "src/app/system/system/system.component";
import { ViewSystemComponent } from "src/app/system/view-system/view-system.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ConfirmationDialogComponent } from "src/app/shared/dialoges/confirmation-dialog/confirmation-dialog.component";
import { ConfirmationComponent, JobTripChoiceDialogComponent } from "src/app/location/location.component";
import { FormDirective } from "src/app/shared/directives/form-validation/form-validation-directive";
import { CommonService } from "src/common.service";
import { HelpComponent } from "./help/help.component";
import { NewSystemComponent } from "src/app/system/new-system/new-system/new-system.component";
import { NewSystemDesignComponent, WarningDialogComponent } from "src/app/system/new-system-design/new-system-design.component";
import { ViewSystemEquipmentComponent } from "src/app/system/view-system-equipment/view-system-equipment.component";
import { NewSystemDesignRoomComponent, RoomErrorDialogComponent } from "src/app/system/new-system-design-room/new-system-design-room.component";
import { LocationsSelectDesignsComponent } from "src/app/hvacLocation/locations/locations-select-designs/locations-select-designs.component";
import { ConfirmLocationDesignComponent } from "src/app/hvacLocation/locations/confirm-location-design/confirm-location-design.component";
import { UnusedLocationComponent } from "src/app/hvacLocation/locations/locations/locations.component";
import { HomeComponent, ResetCounterDialogComponent } from "./home/home.component";
import { CopySystemComponent } from "./design/copy-system/copy-system.component";
import { HvacsubmissionComponent } from './hvacLocation/locationsubmission/hvacsubmission.component';

import { RoomEditDialogComponent } from "src/app/shared/room-edit/room-edit-dialog/room-edit-dialog.component";
import { HvacSubmissionService } from "./hvacLocation/locationsubmission/hvacsubmission.service";
import { ContactUsService } from './hvacLocation/contactus/contactus.service'
import { ContactUsComponent } from "./hvacLocation/contactus/contactus.component";
import { WarningModalComponent } from './raterform/raterform/raterform.component';
import { HVACreviewComponent } from './location/location.component';
import { HomecontainerComponent } from './homecontainer/homecontainer.component';
import { DesignService } from "./design/design.service";
import { SystemService } from "./system/system.service";
import { DrainCamComponent, SafetyInspectionComponent } from './schedule/schedule/schedule.component';
import { CopyMultifamilyComponent, MultifamilyComponent, NewQuestionComponent } from "./multifamily/multifamily.component";
import { FormControlService } from "./multifamily/formfcontrol.service";
import { DynamicFormCreatorComponent } from "./multifamily/dynamicformcreator.component";
import { DynamicFormComponent } from "./multifamily/dynamicform.component";
import { MultiFamilyService } from "./multifamily/multifamily.service";
import { TagsDialogComponent } from "./location/tags.component";

import { GridEmailComponent } from "./utils/grid-email-component";
import { FormLogsComponent } from "./location/formLogsModal/formLogs.component";
import { BatchEditComponent } from "./schedule/schedule/batchEdit.component";
import { FailReasonComponent } from "./schedule/schedule/failreason.component";
import { WarningPopupComponent } from './utils/warning-popup/warning-popup.component';
import { AddNoteDialogComponent } from './utils/add-note-dialog/add-note-dialog.component';
import { LinearProgressComponent,UploadSnackBarComponent } from "./utils/uploadSnackbar/uploadSnackbar.component";
import { ScheduledJobsDialogComponent, TimetrackingComponent } from './timetracking/timetracking.component';
import { MatChipsModule} from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TagService } from "./utils/tags.service";
import { CsvreportsComponent } from './csvreports/csvreports.component';
import { TrackOptionsComponent } from './location/location.component';
import { AddUtilityDialogComponent } from './location/location.component';
import { AdditionalworkComponent } from './additionalwork/additionalwork.component';
import { AdditionalworkService } from "./additionalwork/additionalwork.service";
import { IndivAuditsComponent } from './indiv-audits/indiv-audits.component';
import { TimeadjustmentsComponent, EmployeeNotesViewDialogComponent } from './timeadjustments/timeadjustments.component';
import { OnOurWayLogComponent } from './onourwaylog/onourwaylog.component';
import { BuilderConfirmationsComponent } from './builderconfirmations/builderconfirmations.component';
import { ConifgService } from "./utils/config.service";
import { TrainingDashboardComponent } from './training/training-dashboard/training-dashboard.component';
import { BeginCourseModalComponent } from './training/begin-course-modal/begin-course-modal.component';
import { CourseDetailsModalComponent } from './training/course-details-modal/course-details-modal.component';
import { EmployeeTrainingDetailComponent } from './training/employee-training-detail/employee-training-detail.component';
import { TrainingRequestModalComponent } from './training/training-request-modal/training-request-modal.component';
import { TrainingService } from './training/training.service';
import { PhotoMapDialogComponent } from "./schedule/rating-photos/photo-map-dialog.component";
import { PtoPanelComponent } from "./shared/pto-panel/pto-panel.component";


// MatTableModule,
// MatInputModule,

let baseURL = environment.baseUrl;

@NgModule({
  declarations: [
    AppComponent,
    PtoPanelComponent,
    RemoveDialogComponent,
    ScheduleComponent,
    LoginComponent,
    EditJobComponent,
    ContactsComponent,
    LocationFormComponent,
    RaterformComponent,
    EditContactDialogComponent,
    RaterformSelectorComponent,
    EditPlanDialogComponent,
    EditLocationDialogComponent,
    QaReviewResultDialogComponent,
    EditSubdivisionDialogComponent,
    EditCustomerDialogComponent,
    SelfiePromptComponent,
    RatingPhotosDialogComponent,
    EditCustomerJobDialogComponent,
    ViewFailNotesComponent,
    UnusedLocationComponent,
    ViewLocationComponent,
    PlansComponent,
    HomeComponent,
    HvacHomeComponent,
    HomesComponent,
    CustomersComponent,
    JobtypesComponent,
    EmployeesComponent,
    EmployeeTreeComponent,
    EmployeeTreeEditDialogComponent,
    CitiesComponent,
    SubdivisionsComponent,
    AdminscheduleComponent,
    BuilderjobsComponent,
    CustomerJobsComponent,
    GridDeleteComponent,
    MessagerComponent,
    VisualmapComponent,
    EditJobtypeDialogComponent,
    EditEmployeeDialogComponent,
    EditCityDialogComponent,
    EditJobDialogComponent,
    BillingComponent,
    JobSelectorComponent,
    EditableTextareaComponent,
    AutofocusDirective,
    AutoOpenSelectDirective,
    FilterPipe,
    HeatmapComponent,
    BuilderchecklistsComponent,
    BuilderMustCorrectComponent,
    VersionComponent,
    ViewJobLocationsComponent,
    ExtraNotesRedirectComponent,
    EquipmentComponent,
    DesignComponent,
    DesignFormComponent,
    DesignOverviewComponent,
    HomesComponent,
    ViewEquipmentComponent,
    EquipmentFormComponent,
    SystemComponent,
    ViewSystemComponent,
    ConfirmationDialogComponent,
    ConfirmationComponent,
    SystemDesignComponent,
    FormDirective,
    HelpComponent,
    NewSystemComponent,
    NewSystemDesignComponent,
    ViewSystemEquipmentComponent,
    NewSystemDesignRoomComponent,
    LocationsSelectDesignsComponent,
    ConfirmLocationDesignComponent,
    HvacLocationComponent,
    HvacLocationComponent,
    CopySystemComponent,
    RoomEditDialogComponent,
    HvacsubmissionComponent,
    ContactUsComponent,
    WarningModalComponent,
    HVACreviewComponent,
    LocationComponent,
    HomecontainerComponent,
    WarningDialogComponent,
    ResetDialogComponent,
    RoomErrorDialogComponent,
    ConfirmWarningDialogComponent,
    DrainCamComponent,
    SafetyInspectionComponent,
    RFWarningDialogComponent,
    RFWarningLeakageDialogComponent,
    TimeCardDialogComponent,
    EditTimeModalComponent,
    TimecardNoteDialogComponent,
    StartDayWarningDialogComponent,
    ScheduledJobsWarningDialogComponent,
    PlanModalComponent,
    BigModalDialogComponent,
    GridEmailComponent,
    FormLogsComponent,
    BatchEditComponent,
    FailReasonComponent,
    WarningPopupComponent,
    AddNoteDialogComponent,
    ThermalDialogComponent,
    TripStatusDialogComponent,
    TripRescheduleDialogComponent,
    JobTripChoiceDialogComponent,
    LinearProgressComponent,
    UploadSnackBarComponent,
    ESPercentDialogComponent,
    ESLeakageDialogComponent,
    MultifamilyComponent,
    DynamicFormCreatorComponent,
    DynamicFormComponent,
    NewQuestionComponent,
    CopyMultifamilyComponent,
    TimetrackingComponent,
    ScheduledJobsDialogComponent,
    TagsDialogComponent,
    AtticTentWarningComponent,
    ReportErrorComponent,
    CsvreportsComponent,
    FlagsDialogComponent,
    TrackOptionsComponent,
    AddUtilityDialogComponent,
    SelectBuilderComponent,
    SelectHvacContractorComponent,
    NewScopeDialogComponent,
    MfContactsDialogComponent,
    NewSubDialogComponent,
    HvacGradingWarningComponent,
    DuctLeakageWarningComponent,
    BedroomDefinitionDialogComponent,
    AdditionalworkComponent,
    WrongSupervisorDialogComponent,
    IndivAuditsComponent,
    TimeadjustmentsComponent,
    OnOurWayLogComponent,
    BuilderConfirmationsComponent,
    TrainingDashboardComponent,
    BeginCourseModalComponent,
    CourseDetailsModalComponent,
    EmployeeTrainingDetailComponent,
    TrainingRequestModalComponent,
    EmployeeNotesViewDialogComponent,
    RatingPhotosDialogComponent,
    BigModalDialogComponent,
    PhotoMapDialogComponent,
    ResetCounterDialogComponent,
    PhotoViewerDialogComponent,
  ],
  entryComponents: [
    AppComponent,
    RemoveDialogComponent,
    TripStatusDialogComponent,
    TripRescheduleDialogComponent,
    JobTripChoiceDialogComponent,
    ScheduleComponent,
    LoginComponent,
    EditJobComponent,
    LocationComponent,
    ContactsComponent,
    EditContactDialogComponent,
    UnusedLocationComponent,
    PlansComponent,
    CustomersComponent,
    CustomerJobsComponent,
    GridDeleteComponent,
    EditLocationDialogComponent,
    QaReviewResultDialogComponent,
    EditSubdivisionDialogComponent,
    EditPlanDialogComponent,
    SelfiePromptComponent,
    RatingPhotosDialogComponent,
    EditCustomerDialogComponent,
    EditJobtypeDialogComponent,
    EditEmployeeDialogComponent,
    EmployeeTreeEditDialogComponent,
    EditCityDialogComponent,
    EditCustomerJobDialogComponent,
    EditJobDialogComponent,
    RaterformComponent,
    ViewFailNotesComponent,
    BillingComponent,
    RaterformSelectorComponent,
    BuilderchecklistsComponent,
    BuilderMustCorrectComponent,
    ViewJobLocationsComponent,
    CopySystemComponent,
    RoomEditDialogComponent,
    HvacsubmissionComponent,
    ContactUsComponent,
    WarningModalComponent,
    HVACreviewComponent,
    WarningDialogComponent,
    ResetDialogComponent,
    RoomErrorDialogComponent,
    ConfirmWarningDialogComponent,
    DrainCamComponent,
    SafetyInspectionComponent,
    RFWarningDialogComponent,
    RFWarningLeakageDialogComponent,
    TimeCardDialogComponent,
    EditTimeModalComponent,
    TimecardNoteDialogComponent,
    StartDayWarningDialogComponent,
    ScheduledJobsWarningDialogComponent,
    PlanModalComponent,
    BigModalDialogComponent,
    GridEmailComponent,
    FormLogsComponent,
    BatchEditComponent,
    FailReasonComponent,
    WarningPopupComponent,
    AddNoteDialogComponent,
    ThermalDialogComponent,
    TripStatusDialogComponent,
    TripRescheduleDialogComponent,
    JobTripChoiceDialogComponent,
    LinearProgressComponent,
    ESPercentDialogComponent,
    ESLeakageDialogComponent,
    MultifamilyComponent,
    DynamicFormCreatorComponent,
    DynamicFormComponent,
    NewQuestionComponent,
    CopyMultifamilyComponent,
    ScheduledJobsDialogComponent,
    TagsDialogComponent,
    AtticTentWarningComponent,
    ConfirmationDialogComponent,
    ConfirmationComponent,
    RemoveDialogComponent,
    ReportErrorComponent,
    FlagsDialogComponent,
    TrackOptionsComponent,
    AddUtilityDialogComponent,
    SelectBuilderComponent,
    SelectHvacContractorComponent,
    NewScopeDialogComponent,
    MfContactsDialogComponent,
    NewSubDialogComponent,
    HvacGradingWarningComponent,
    DuctLeakageWarningComponent,
    BedroomDefinitionDialogComponent,
    AdditionalworkComponent,
    WrongSupervisorDialogComponent,
    BeginCourseModalComponent,
    CourseDetailsModalComponent,
    TrainingRequestModalComponent,
    EmployeeNotesViewDialogComponent,
    PhotoMapDialogComponent,
    ResetCounterDialogComponent,
    PhotoViewerDialogComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    Ng2SearchPipeModule,
    FlexLayoutModule,
    AppRoutingModule,
    MatDatepickerModule,
    MatButtonModule,
    BrowserAnimationsModule,
    MatMomentDateModule,
    TableModule,
    MatDialogModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatMenuModule,
    FontAwesomeModule,
    MatTabsModule,
    MatRippleModule,
    MatSnackBarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatRadioModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSlideToggleModule,
    ScrollingModule,
    MatChipsModule,
    MatTooltipModule,
  ],
  // tslint:disable-next-line: max-line-length
  providers: [
    HomeService,
    GlobalEmailService,
    HeatMapService,
    ContactsService,
    BCService,
    ScheduleService,
    LocationService,
    RaterFormService,
    PlanService,
    CustomerService,
    EmployeeService,
    SubdivisionService,
    JobTypeService,
    CityService,
    BillingService,
    GridDeleteComponent,
    MessagerComponent,
    FileUploaderService,
    LoggingService,
    EquipmentService,
    CommonService,
    HvacSubmissionService,
    ContactUsService,
    DesignService,
    SystemService,
    WarningPopupComponent,
    LinearProgressComponent,
    UploadSnackBarComponent,
    FormControlService,
    MultiFamilyService,
    TagService,
    CSVreportsService,
    AdditionalworkService,
    ConifgService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
